/* Ampliar imágenes de la ficha de producto: portada + páginas de muestra.
   Clic/toque en la imagen → visor grande con miniaturas seleccionables, flechas, teclado, deslizar y cerrar. */
(function(){
  var d=document,data=d.getElementById('pzoom');
  if(!data)return;
  var items;try{items=JSON.parse(data.textContent)}catch(e){return}
  if(!items.length)return;
  var box,img,cnt,thumbs,cur=0,last=null,tx=null;

  function build(){
    if(box)return;
    box=d.createElement('div');box.className='lbx';box.hidden=true;
    box.setAttribute('role','dialog');box.setAttribute('aria-modal','true');box.setAttribute('aria-label','Imágenes del producto');
    box.innerHTML='<button class="lbx-x" type="button" aria-label="Cerrar">&times;</button>'+
      '<button class="lbx-p" type="button" aria-label="Imagen anterior">&#8249;</button>'+
      '<button class="lbx-n" type="button" aria-label="Imagen siguiente">&#8250;</button>'+
      '<figure class="lbx-f"><img alt="" decoding="async"></figure>'+
      '<div class="lbx-c" aria-live="polite"></div><div class="lbx-t"></div>';
    d.body.appendChild(box);
    img=box.querySelector('.lbx-f img');cnt=box.querySelector('.lbx-c');thumbs=box.querySelector('.lbx-t');
    items.forEach(function(it,i){
      var b=d.createElement('button');b.type='button';b.className='lbx-th';b.setAttribute('aria-label','Ver imagen '+(i+1));
      var t=d.createElement('img');t.src=it.thumb;t.alt='';t.loading='lazy';b.appendChild(t);
      b.addEventListener('click',function(){show(i)});thumbs.appendChild(b);
    });
    if(items.length<2){box.classList.add('lbx-one')}
    box.querySelector('.lbx-x').addEventListener('click',close);
    box.querySelector('.lbx-p').addEventListener('click',function(){show(cur-1)});
    box.querySelector('.lbx-n').addEventListener('click',function(){show(cur+1)});
    box.addEventListener('click',function(e){if(e.target===box||e.target.classList.contains('lbx-f'))close()});
    box.addEventListener('touchstart',function(e){tx=e.touches[0].clientX},{passive:true});
    box.addEventListener('touchend',function(e){
      if(tx===null)return;var dx=e.changedTouches[0].clientX-tx;tx=null;
      if(Math.abs(dx)>50)show(cur+(dx<0?1:-1));
    });
  }
  function show(i){
    var n=items.length;cur=(i+n)%n;
    img.classList.add('lbx-ld');
    img.onload=function(){img.classList.remove('lbx-ld')};
    img.src=items[cur].full;img.alt=items[cur].alt||'';
    cnt.textContent=(cur+1)+' / '+n;
    [].forEach.call(thumbs.children,function(b,k){
      var on=k===cur;b.classList.toggle('on',on);if(on){b.setAttribute('aria-current','true');b.scrollIntoView({block:'nearest',inline:'center'})}else b.removeAttribute('aria-current');
    });
    [cur+1,cur-1].forEach(function(k){var p=new Image();p.src=items[(k+n)%n].full});
  }
  function open(i){
    build();last=d.activeElement;box.hidden=false;
    d.documentElement.classList.add('lbx-lock');
    show(i);box.querySelector('.lbx-x').focus();
  }
  function close(){
    if(!box||box.hidden)return;
    box.hidden=true;d.documentElement.classList.remove('lbx-lock');
    if(last&&last.focus)last.focus();
  }
  d.addEventListener('keydown',function(e){
    if(!box||box.hidden)return;
    if(e.key==='Escape')close();
    else if(e.key==='ArrowRight')show(cur+1);
    else if(e.key==='ArrowLeft')show(cur-1);
    else if(e.key==='Tab'){ /* foco atrapado dentro del visor */
      var f=[].slice.call(box.querySelectorAll('button')).filter(function(b){return b.offsetParent!==null});
      if(!f.length)return;var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&d.activeElement===a){e.preventDefault();z.focus()}
      else if(!e.shiftKey&&d.activeElement===z){e.preventDefault();a.focus()}
    }
  });
  d.addEventListener('click',function(e){
    var t=e.target.closest('[data-zi]');if(!t)return;
    e.preventDefault();open(+t.getAttribute('data-zi'));
  });
  d.addEventListener('keydown',function(e){
    if((e.key==='Enter'||e.key===' ')&&e.target.matches&&e.target.matches('[data-zi]')){e.preventDefault();open(+e.target.getAttribute('data-zi'))}
  });
})();
